import React, { useEffect } from 'react';
import PageWrapper from '../../components/PageWrapper';
import { useAuthEffects } from '../../components/Auth';
import { Avatar, Box, List, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { useNavigate } from 'react-router-dom';
import { useOrderListLoadMutation } from '../../services/orders';
import { useAppSelector } from '../../hooks';
import dayjs from 'dayjs';
import { selectOrdersListItems } from './orderSlice';
import { ListViewStatusStepper } from './components/Stepper';
import { OrderListItem, OrderStatus } from '../../types';

const STATUS_LABELS = {
	[OrderStatus.Created]: 'Waiting for offer',
	[OrderStatus.Prepared]: 'Pending',
	[OrderStatus.Paid]: 'Paid',
	[OrderStatus.Shipped]: 'Shipped',
	[OrderStatus.Cancelled]: 'Cancelled',
	[OrderStatus.Rejected]: 'Rejected',
};

const OrdersView = () => {
	useAuthEffects();

	const navigate = useNavigate();
	const [orderListLoadMutation] = useOrderListLoadMutation();
	const orders = useAppSelector(selectOrdersListItems);

	useEffect(() => {
		orderListLoadMutation({});
	}, []);

	return <PageWrapper disableFooter={!orders.length} noScroll={!orders.length} maxWidth='md'>
		{!orders.length ? <Box flex={1} display='flex' alignItems='center' justifyContent='center'>
			<Typography fontSize='1.2rem'>Your purchases will show up here!</Typography>
		</Box> :
			<Box display='flex' flexDirection='column' gap={2} mt={2}>
				<Typography variant='h6'>My Purchases History</Typography>
				<List>
					{orders.map((order: OrderListItem, i: number) => (
						<ListItemButton key={i} onClick={() => navigate(`/purchases/${order.id}`)}>
							<ListItemAvatar>
								<Avatar src={order.vendorImgUrl} variant='square' sx={{ width: 96, height: 96, mr: 2, borderRadius: 2 }}>
									<FolderIcon />
								</Avatar>
							</ListItemAvatar>
							<ListItemText
								primary={<span>{order.itemsCount} items from {order.vendorName}</span>}
								secondary={dayjs(order.createdAt).format('MMMM D, HH:mm')}
							/>
							<Box justifyItems='center'>
								<Box>
									{STATUS_LABELS[order.status]}
								</Box>
								<ListViewStatusStepper orderStatus={order.status} isCancelled={[OrderStatus.Cancelled, OrderStatus.Rejected].includes(order?.status)} />
							</Box>
						</ListItemButton>
					))}
				</List> 
			</Box>}
	</PageWrapper>;
};

export default OrdersView;
